import { render, staticRenderFns } from "./CustomerPortalOrders.vue?vue&type=template&id=7e8eed6b&scoped=true&"
import script from "./CustomerPortalOrders.vue?vue&type=script&lang=js&"
export * from "./CustomerPortalOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8eed6b",
  null
  
)

export default component.exports